import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  iconfont: 'md',
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#422d68',
        secondary: '#5b96e7',
        info: '#48d5e5',
        success: '#93cc47',
        error: '#fb376c'
      },
      dark: {
        primary: '#422d68',
        secondary: '#5b96e7',
        info: '#48d5e5',
        success: '#93cc47',
        error: '#fb376c'
      }
    }
  }
});
